import React, { useContext, useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import NewObject from "../../../overbox/sheet/seller/NewObject";
import ObjectSheet from "../../../sheet/ObjectSheet";
import Listing from "../../../table/Listing";
import FilterPopup from "../../../table/FilterPopup";
import SellerController from "../../../../stories/_setting/Sellers/SellerController";
import SellerGroupController from "../../../../stories/_setting/SellerGroups/SellerGroupController";
import ListingContext from "../../../../context/ListingContext";
import BackofficeContext from "../../../../context/BackofficeContext";
import "../../../../css/page/content/seller/Seller.css";
import usePrevious from "../../../../class/tool/usePrevious";

const Sellers = () => {
    const item = "sellers";
    const itemClass = "seller";
    const titleWindow = "Vendeurs";
    const placeholderSearch = "un vendeur";
    const titleNbItems = "vendeurs";
    const emptyList = "Aucun vendeur";
    const textRemoveButton = "ce vendeur";
    const activeHistory = false;
    const { setEvent } = useContext(BackofficeContext);
    const [ pageSelect, setPageSelect ] = useState(1);
    const [ loading, setLoading ] = useState(true);
    const [ groups, setGroups ] = useState([]);
    const [ list, setList ] = useState([]);
    const [ pagination, setPagination ] = useState(null);
    const [ perPage, setPerPage ] = useState(25);
    const [ sortingName, setSortingName ] = useState("updated_at");
    const [ sortingValue, setSortingValue ] = useState("desc");
    const [ filters, setFilters ] = useState({});
    const [ filterValues, setFilterValues ] = useState({});
    const [ contextValues, setContextValues ] = useState({});
    const [ showFilters, setShowFilters ] = useState(false);
    const prevPageSelect = usePrevious(pageSelect);
    const prevPerPage = usePrevious(perPage);

    const initFilters = () => {
        setFilterValues(prev => ({
            ...prev,
            group_id: null,
            inputs: [],
            input: null
        }));
    }
    const getSellers = (pPage = 1, pPerPage = 25, pSortingName = "", pSortingValue = "") => {
        let controller;
        let paramPage = pPage !== 1 ? pPage : pageSelect;
        let paramPerPage = pPerPage !== 25 ? pPerPage : perPage;
        let paramSortingName = pSortingName !== "" ? pSortingName : sortingName;
        let paramSortingValue = pSortingValue !== "" ? pSortingValue : sortingValue;

        setLoading(true);

        controller = new SellerController();
        controller._callback = handleGetSellers;
        controller.index(filterValues, paramPage, paramPerPage, paramSortingName, paramSortingValue, false);
    }
    const handleGetSellers = (list, error, pagination, status) => {
        switch (status) {
            case 200:
                setList(list);
                setPagination(pagination !== undefined ? pagination : null );
                break;
            default:
                setEvent({
                    type: "error",
                    text: "Une erreur s'est produite lors de la récupération des vendeurs"
                });
                break;
        }

        setLoading(false);
    }
    const getGroupsTree = () => {
        const controller = new SellerGroupController();
        controller._callback = handleGetGroupsTree;
        controller.index(null, 0, 0, "", "", true);
    }
    const handleGetGroupsTree = (list, error, pagination, status) => {
        switch (status) {
            case 200:
                let groupsTmp = [
                    {
                        name: "Tous les groupes",
                        id: 0
                    }
                ];

                for (let i in list) {
                    groupsTmp.push({
                        name: list[i].name,
                        id: list[i].id
                    });
                }

                setGroups(groupsTmp);
                break;
            default:
                console.log(error);
                break;
        }
    }
    const updateFilters = () => {
        setFilters(prev => ({
            ...prev,
            sellerGroups: groups
        }));
    }
    const updatePageSelect = page => {
        setPageSelect(page);
    }
    const handleRefresh = (force = true) => {
        if (force) {
            if (pageSelect !== 1) {
                setPageSelect(1);
                return;
            }
        }

        getSellers(pageSelect, perPage, sortingName, sortingValue);
    }
    const handleUpdate = object => {
        let index = list.findIndex(item => item.id === object.id);
        if (index < 0) return;

        let listTmp = list.slice();
        let keys = Object.keys(listTmp[index]);
        let key = "";

        for(let i in keys) {
            key = keys[i];

            if (object[key] !== undefined)
                listTmp[index][key] = object[key];
        }

        setList(listTmp)
    }
    const handleRemove = () => {
        handleRefresh()
    }
    const openFilters = () => {
        setShowFilters(true);
    }
    const closeFilters = () => {
        setShowFilters(false);
    }
    const validFilters = values => {
        closeFilters();
        setFilterValues(values);
    }

    const model = [
        {
            "class": "name",
            "sortingParam": "name",
            "title": "Nom",
            "attributes": ["fullname"],
            "type": "text"
        }, {
            "class": "reference",
            "sortingParam": "reference",
            "title": "Référence",
            "attributes": ["reference"],
            "type": "text"
        }, {
            "class": "group",
            "sortingParam": "group",
            "title": "Groupe",
            "attributes": ["groupName"],
            "type": "text"
        }
    ];
    const options = [
        {
            "class": "add moreActions",
            "title": "Créer " + placeholderSearch,
            "action": "",
            "link": "/" + item + "/new"
        }
    ];
    const secondaryOptions = [
        {
            "class": "blue addMany",
            "title": "Ajouter plusieurs " + titleNbItems,
            "action": "handleAddMany",
            "link": ""
        }
    ];

    useEffect(() => {
        document.title = "Back office - " + titleWindow;

        getGroupsTree();
        initFilters();
    }, []);
    useEffect(() => {
        updateFilters();
    }, [groups]);
    useEffect(() => {
        if (prevPageSelect === undefined || prevPerPage === undefined) return;

        if (pageSelect !== prevPageSelect || perPage !== prevPerPage)
            handleRefresh(false);
    }, [pageSelect, perPage]);
    useEffect(() => {
        if (Object.keys(filterValues).length === 0) return;

        handleRefresh(true);
    }, [filterValues]);
    useEffect(() => {
        setContextValues(prev => ({
            ...prev,
            page: pageSelect,
            typeFilters: "sellers",
            filters,
            filterValues,
            showFilters,
            openFilters,
            closeFilters,
            validFilters
        }));
    }, [showFilters, pageSelect, filters, filterValues]);

    return(
        <ListingContext.Provider value={contextValues}>
            <FilterPopup />
            <Listing
                item={ item }
                itemClass={ itemClass }
                placeholderSearch={ placeholderSearch }
                titleNbItems={ titleNbItems }
                emptyList={ emptyList }
                model={ model }
                options={ options }
                secondaryOptions={ secondaryOptions }
                activeHistory={ activeHistory }
                pageSelect={ pageSelect }
                updatePageSelect={ updatePageSelect }
                list={ list }
                loading={ loading }
                pagination={ pagination }
                checkable={ false }
                openable={ true }
                setPerPage={ setPerPage }
                sortingName={ sortingName }
                sortingValue={ sortingValue }
                setSortingName={ setSortingName }
                setSortingValue={ setSortingValue }
            />
            <Switch>
                <Route exact path={"/" + item + "/new"}>
                    <NewObject handleIndex={ handleRefresh } />
                </Route>
                <Route exact path={"/" + item + "/:id/(information|barcodes)"}>
                    <ObjectSheet
                        objectType={ itemClass }
                        previousLink={ item }
                        textRemoveButton={ textRemoveButton }
                        handleUpdate={handleUpdate}
                        handleRemove={handleRemove}
                    />
                </Route>
            </Switch>
        </ListingContext.Provider>
    );
}

export default Sellers;
